export default __webpack_public_path__ + "static/media/night.bb975013.png";